module.exports = __webpack_public_path__ + "static/media/virtualmirrorVN.3dae3463.png";